import DataObjectField from "@/utilities/classes/data-object-field";

const buildCreateProjectSummaryObject = (vData, ProjectWorkbookURL, ProposalDocumentsURL, councilDistricts, streetAddresses) => {

    const fields = [
        new DataObjectField(vData.Organization, 98),
        new DataObjectField(vData.Address.Street1, 193),
        new DataObjectField(vData.Address.Street2, 194),
        new DataObjectField(vData.Address.City, 195),
        new DataObjectField(vData.Address.State, 196),
        new DataObjectField(vData.Address.Zip, 197),
        new DataObjectField(vData.Address.Country, 198),
        new DataObjectField(vData.EntityType, 464),
        new DataObjectField(vData.DeveloperDescription, 465),
        new DataObjectField(vData.ProjectName, 97),
        new DataObjectField(vData.ProposalType, 487),
        new DataObjectField(vData.NumberOfUnits, 105),
        new DataObjectField(vData.FundingRequested, 335),
        new DataObjectField(vData.TotalDevelopmentCost, 122),
        new DataObjectField(vData.TotalConstructionCost, 123),
        new DataObjectField(vData.SquareFootage, 449),
        new DataObjectField(vData.DevelopmentCategory, 229),
        new DataObjectField(vData.DevelopmentCategory2, 488),
        new DataObjectField(vData.ExpirationYear, 466),
        new DataObjectField(vData.PopulationServed.join(";"), 232),
        new DataObjectField(vData.PopulationServedDescription, 104),
        new DataObjectField(vData.ServicesOffered, 468),
        new DataObjectField(vData.ServicesOfferedDescription, 469),
        new DataObjectField(vData.MixedUse, 470),
        new DataObjectField(vData.CommercialTenant, 471),
        new DataObjectField(vData.MixedIncomeHousingBonus, 500),
        new DataObjectField(vData.Attributes.includes("Permanent Affordability"), 489),
        new DataObjectField(vData.Attributes.includes("High Opportunity Area"), 493),
        new DataObjectField(vData.Attributes.includes("Place-Based Strategy Area"), 494),
        new DataObjectField(vData.Attributes.includes("Affordable Preservation"), 490),
        new DataObjectField(vData.Attributes.includes("Permanent Support Housing"), 491),
        new DataObjectField(vData.Attributes.includes("Non-Congregate Shelter"), 492),
        new DataObjectField(vData.Attributes.includes("Conversion of NOAH into Subsidized Affordable Housing"), 510),
        new DataObjectField(vData.StrategyArea.includes("Sharswood Blumberg Choice"), 495),
        new DataObjectField(vData.StrategyArea.includes("North Central Choice"), 496),
        new DataObjectField(vData.StrategyArea.includes("Bartram Village Choice"), 497),
        new DataObjectField(vData.StrategyArea.includes("22nd Police District"), 498),
        new DataObjectField(vData.StrategyArea.includes("Promise Zone neighborhood"), 499),
        new DataObjectField(vData.ProjectDescription, 505),
        new DataObjectField(vData.AdditionalFeatures, 506),
        new DataObjectField(vData.NumberOfEfficiencyUnits, 442),
        new DataObjectField(vData.NumberOfOneBedroomUnits, 443),
        new DataObjectField(vData.NumberOfTwoBedroomUnits, 444),
        new DataObjectField(vData.NumberOfThreeBedroomUnits, 445),
        new DataObjectField(vData.NumberOfFourBedroomUnits, 446),
        new DataObjectField(vData.Mobility, 106),
        new DataObjectField(vData.Sensory, 107),
        new DataObjectField(vData.Visitable, 108),
        new DataObjectField(vData.Clearinghouse, 109),
        new DataObjectField(vData.AMI0to20, 476),
        new DataObjectField(vData.AMI20to30, 477),
        new DataObjectField(vData.AMI30to50, 478),
        new DataObjectField(vData.AMI50to60, 479),
        new DataObjectField(vData.AMI60to80, 480),
        new DataObjectField(vData.AMI80to120, 481),
        new DataObjectField(vData.AMI120Plus, 482),
        new DataObjectField(vData.SiteControl, 472),
        new DataObjectField(vData.ZoningSecured, 473),
        new DataObjectField(vData.CommunityMeeting, 474),
        new DataObjectField(vData.EstimatedConstructionTimeline, 475),
        new DataObjectField(ProjectWorkbookURL, 483),
        new DataObjectField(ProposalDocumentsURL, 484),
        //new DataObjectField(EOPFormURL, 485),
        new DataObjectField([...new Set(councilDistricts)].join(";"), 219),
        new DataObjectField(streetAddresses.join(", "), 99)
    ];

  const dataObject = {
    qdbapi: {
      udata: "SHARC_CREATE_PROJECT",
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      clist: "3",
      field: fields
    }
  };
  return dataObject;
};

export default buildCreateProjectSummaryObject;